<template>
    <div>
        <v-container>
            <v-row>
                <v-col md="7" style="padding-top:0">
                    <h1 class="text-left" style="padding-top:70px">Empowering Wealth For Your Business</h1>
                    <div class="line"></div>
                    <p class="text-left">Jadilah bagian dari pertumbuhan kesejahteraan pengguna Anda dengan
                        wealth technology dari FUNDtastic+. Mitra yang telah bergabung bersama kami:</p>
                    <v-row justify="space-around" class="thumbimage">
                        <!-- <v-col class="col-content">
                        <button @click="setmodel(0)" :class="{ 'activethumb' : model == 0}"> -->
                            <!-- <div class="text-center"> -->
                                <!-- <div class="img-thumb">
                                    <v-img src="https://assets.invisee.com/statis/revamp/business/travel-3x.png" max-height="48px" max-width="48px" class="mx-auto"></v-img>
                                </div> -->
                            <!-- </div> -->
                            <!-- Online Travel Agency -->
                        <!-- </button>
                        </v-col> -->
                        <v-col class="col-content">
                        <button @click="setmodel(1)" :class="{ 'activethumb' : model == 1}">
                            <div class="img-thumb">
                            <v-img src="https://assets.invisee.com/statis/revamp/business/marketplace-3x.png" max-height="48px" max-width="48px" class="mx-auto"></v-img>
                            </div>
                            Market Place
                        </button>
                        </v-col>
                        <v-col class="col-content">
                        <button @click="setmodel(2)" :class="{ 'activethumb' : model == 2}">
                            <div class="img-thumb">
                            <v-img src="https://assets.invisee.com/statis/revamp/business/mobile_banking-3x.png" max-height="48px" max-width="48px" class="mx-auto"></v-img>
                            </div>
                            E-Wallet
                        </button>
                        </v-col>
                        <v-col class="col-content">
                        <button @click="setmodel(3)" :class="{ 'activethumb' : model == 3}">
                            <div class="img-thumb">
                            <v-img src="https://assets.invisee.com/statis/revamp/business/bank-3x.png" max-height="48px" max-width="48px" class="mx-auto"></v-img>
                            </div>
                            Bank
                        </button>
                        </v-col>
                        <v-col class="col-content">
                        <button @click="setmodel(4)" :class="{ 'activethumb' : model == 4}">
                            <div class="img-thumb">
                            <v-img src="https://assets.invisee.com/statis/revamp/business/project_designing-3x.png" max-height="48px" max-width="48px" class="mx-auto"></v-img>
                            </div>
                            Custom Project
                        </button>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col md="5" style="padding-top:0">
                    <v-carousel
                        v-model="model"
                        cycle
                        height="340"
                        width="396"
                        hide-delimiter-background
                        :show-arrows="false"
                        hide-delimiters
                    >
                        <v-carousel-item
                        v-for="(item,i) in items"
                        :key="i"
                        :src="item.src"
                        ></v-carousel-item>
                    </v-carousel>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                model: 1,
                items: [
                {
                    src: require('@/assets/revamp/business/slide1.png'),
                },
                {
                    src: require('@/assets/revamp/business/slide2.png'),
                },
                {
                    src: require('@/assets/revamp/business/slide3.png'),
                },
                {
                    src: require('@/assets/revamp/business/slide4.png'),
                },
                {
                    src: require('@/assets/revamp/business/slide5.png'),
                },
                // {
                //     src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg',
                // },
                ],
            }
        },
        methods: {
            setmodel(_index) {
                switch (_index) {
                // case 0:
                //     this.model = 0;
                //     break;
                case 1:
                    this.model = 1;
                    break;
                case 2:
                    this.model = 2;
                    break;
                case 3:
                    this.model = 3;
                    break;
                case 4:
                    this.model = 4;
                    break;
                }
            },
        },
    }
</script>

<style scoped>
    .thumbimage button .img-thumb{
        background-color: rgba(207, 224, 245, 1);
        padding: 15px;
        border-radius: 45px;
        width: fit-content;
        margin: 0 auto;
        transition: margin 700ms;
    }
    .thumbimage{
        padding: 40px 0;
        font-size: 12px;
    }
    .activethumb .img-thumb{
        margin-top: -15px !important;
        transition: margin 700ms;
    }
    .activethumb{
        color: rgba(0, 127, 207, 1);
        font-weight: bold;
    }
</style>